import { render, staticRenderFns } from "./partnerShipsDetail.vue?vue&type=template&id=a049a0b8&scoped=true"
import script from "./partnerShipsDetail.vue?vue&type=script&lang=js"
export * from "./partnerShipsDetail.vue?vue&type=script&lang=js"
import style0 from "./partnerShipsDetail.vue?vue&type=style&index=0&id=a049a0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a049a0b8",
  null
  
)

export default component.exports